module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0015392_login.fb294dcc.png";